const footer = document.querySelector(".footer");

if (footer) {
    const footerVar = getComputedStyle(document.documentElement).getPropertyValue('--footer');

    function footerResize() {
        const footerHeight = footer.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--footer', footerHeight + "px");
    }

    window.onresize = footerResize;

    footerResize();
}

document.querySelectorAll("[data-cookie-settings]").forEach(function (button) {
    button.addEventListener("click", function () {
        window.klaro && window.klaro.show();
    });
});